import { h } from 'preact';

const Arrow = () => (
	<svg width="32" height="8" viewBox="0 0 32 8" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M31.5484 4.35355C31.7437 4.15829 31.7437 3.84171 31.5484 3.64644L28.3664 0.464464C28.1711 0.269201 27.8546 0.269201 27.6593 0.464464C27.464 0.659726 27.464 0.976308 27.6593 1.17157L30.4877 4L27.6593 6.82842C27.464 7.02369 27.464 7.34027 27.6593 7.53553C27.8546 7.73079 28.1711 7.73079 28.3664 7.53553L31.5484 4.35355ZM4.32905e-08 4.5L31.1948 4.5L31.1948 3.5L-4.32905e-08 3.5L4.32905e-08 4.5Z" fill="currentColor" />
	</svg>
);

export default Arrow;
